import React from 'react';

import numberWithCommas from 'utils/numberWithCommas';

const t = {
  kg: 'kg',
};

const WeightCell = ({ weight }) => {
  if (typeof weight === 'undefined') {
    return null;
  }

  return (
    <>
      {numberWithCommas(weight)} {t.kg}
    </>
  );
};

export default WeightCell;
